<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

(function () {
    var selector =
        '.jdgm-widget:not(.jdgm-review-widget--small,.jdgm-review-widget--medium) .jdgm-rev-widg__title';

    function apply() {
        var el = document.querySelector(selector);

        if (!el) {
            return;
        }

        el.textContent = 'Reviews';
        el.style.visibility = 'visible';
    }

    apply();

    var tries = 0;
    var t = setInterval(function () {
        apply();
        tries += 1;

        if (tries >= 60) {
            clearInterval(t);
        }
    }, 100);
})();
